import { create } from 'zustand';
import type { Button } from '@livepuls/types';

/**
 * Clipboard für Button-Copy/Paste. Speichert das Original-Button-Objekt,
 * damit beim Einfügen über `POST /api/v1/buttons/:id/duplicate-to/:panelId`
 * derselbe Re-Targeting-Trick genutzt werden kann wie beim Drag&Drop.
 */
interface ClipboardState {
  button: Button | null;
  copy(b: Button): void;
  clear(): void;
}

export const useClipboardStore = create<ClipboardState>((set) => ({
  button: null,
  copy: (b) => set({ button: b }),
  clear: () => set({ button: null }),
}));
